import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, concatMap, debounce, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { BatteryTestSchedulerActionTypes, BatteryTestSchedulerActions } from '../actions/battery-test-scheduler.actions';
import {Store, select, Action} from '@ngrx/store';
import {BatteryService} from '../../../services/battery.service';
import * as featureActions from '../../index';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';


@Injectable()
export class BatteryTestSchedulerEffects {
  constructor(private actions$: Actions<BatteryTestSchedulerActions>,
              private batteryService: BatteryService,
              private store$: Store<fromStore.State>) {}

  getBatteryTestScheduler$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestSchedulerActionTypes.LoadBatteryTestScheduler),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.GetBatteryTestScheduler(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body) {
            return [new featureActions.LoadBatteryTestSchedulerSuccess(res.msg.body)];
          } else {
            return [new featureActions.LoadBatteryTestSchedulerFail()];
          }
        }),
        catchError(error => {
          return of(new featureActions.LoadBatteryTestSchedulerFail());
        })
      );
    })
  ));

  getBatteryTestScheduleDetail$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.GetBatteryTestSchedulerDetail(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body) {
            return [new featureActions.LoadBatteryTestSchedulerDetailSuccess(res.msg.body)];
          } else {
            return [new featureActions.LoadBatteryTestSchedulerDetailFail()];
          }
        }),
        catchError(error => {
          return of(new featureActions.LoadBatteryTestSchedulerDetailFail());
        })
      );
    })
  ));

  addBatteryTestScheduler$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.BatteryTestSchedulerActionTypes.AddBatteryTestScheduler),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddBatteryTestScheduler
      };
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.AddBatteryTestScheduler(params).pipe(
        switchMap((res) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Add Battery Test Scheduler Success' })];
          } else {
            // updateRes.errmsg = res.errmsg.body;
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: res.Msg }), new featureActions.AddBatteryTestSchedulerFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.AddBatteryTestSchedulerFail());
        })
      );
    })
  ));
  

  updateBatteryTestScheduler$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.BatteryTestSchedulerActionTypes.UpdateBatteryTestScheduler),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateBatteryTestScheduler
      };
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.UpdateBatteryTestScheduler(params).pipe(
        switchMap((res) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Update Battery Test Scheduler Success' })];
          } else {
            // updateRes.msg = 'Update Battery Test Scheduler Fail';
            // updateRes.errmsg = res.errmsg.body;
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: res.Msg }), new featureActions.UpdateBatteryTestSchedulerFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.UpdateBatteryTestSchedulerFail());
        })
      );
    })
  ));

  deleteBatteryTestScheduler$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.BatteryTestSchedulerActionTypes.DeleteBatteryTestScheduler),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteBatteryTestScheduler
      };
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.DeleteBatteryTestScheduler(params).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete Battery Test Scheduler Success' })];
          } else {
            return of(new featureActions.DeleteBatteryTestSchedulerFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.DeleteBatteryTestSchedulerFail());
        })
      );
    })
  ));

  getBatteryTestSchedulerResult$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResult),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.ReadBatteryTestSchedulerResults(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body) {
            return [new featureActions.LoadBatteryTestSchedulerResultSuccess(res.msg.body)];
          } else {
            return [new featureActions.LoadBatteryTestSchedulerResultFail()];
          }
        }),
        catchError(error => {
          return of(new featureActions.LoadBatteryTestSchedulerResultFail());
        })
      );
    })
  ));

  execBatteryTestScheduler$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.BatteryTestSchedulerActionTypes.ExecBatteryTestScheduler),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ExecBatteryTestScheduler
      };
      const params = { ...action.payload, otp: user.otp };
      return this.batteryService.ExecBatteryTestScheduler(params).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Exec Battery Test Scheduler Success' })];
          } else {
            return of(new featureActions.ExecBatteryTestSchedulerFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.ExecBatteryTestSchedulerFail());
        })
      );
    })
  ));
}
